import { render, staticRenderFns } from "./scStreaming.vue?vue&type=template&id=5bc79c0e&scoped=true&"
import script from "./scStreaming.vue?vue&type=script&lang=js&"
export * from "./scStreaming.vue?vue&type=script&lang=js&"
import style0 from "./scStreaming.vue?vue&type=style&index=0&id=5bc79c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc79c0e",
  null
  
)

export default component.exports